import React from 'react';
import PropTypes from 'prop-types';

import { Anchor, Text } from '@zillow/constellation-10';

const timeTilReset = 5000;

export default class ActionInProgress extends React.Component {
  static propTypes = {
    onResetAction: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.resetAction = this.resetAction.bind(this);

    this.state = {
      contactTimeout: setTimeout(this.resetAction, timeTilReset),
    };
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  clearTimer() {
    clearTimeout(this.state.contactTimeout);
  }

  resetAction() {
    const { onResetAction } = this.props;

    this.clearTimer();
    onResetAction();
  }

  render() {
    return (
      <Text>
        {this.props.children}
        &nbsp;
        <Anchor onClick={this.resetAction}>Cancel</Anchor>
      </Text>
    );
  }
}
